import Axios from "../plugins/axios";
import { urls } from "../admin/config/urls";

export class CMSAuthModuleTypes {
  static dms = "dms";

  static gls = "gls";

  static photos = "photos";

  static article = "article";

  static menu = "menu";

  static sitemap = "sitemap";
}

export class CMSAuthPermissionTypes {
  static dms_add_fileset = "dms.add_fileset";

  static dms_edit_fileset = "dms.edit_fileset";

  static dms_delete_fileset = "dms.delete_fileset";

  static dms_add_file = "dms.add_file";

  static dms_edit_file = "dms.edit_file";

  static dms_delete_file = "dms.delete_file";

  static article_change_glsarticle = "article.change_glsarticle";

  static article_delete_glsarticle = "article.delete_glsarticle";

  static article_add_content = "article.add_content";

  static article_change_content = "article.change_content";

  static article_add_contentcomponent = "article.add_contentcomponent";

  static article_change_contentcomponent = "article.change_contentcomponent";
}

export class CMSAuth {
  /** @param {ModulePermissions} permissions */
  constructor(permissions) {
    /**
     * @type {Object}
     * @private
     */
    this._user = permissions.user;
    /**
     * @type {Object}
     * @private
     */
    this._modulePerms = permissions.module_perms;
    /**
     * @type {Object}
     * @private
     */
    this._permsByModule = {};
    /**
     * @type {Boolean}
     * @private
     */
    this._isSuperuser = permissions.user?.is_superuser;
    /**
     * @type {Boolean}
     * @private
     */
    this._isStaff = permissions.user?.is_staff;
    /**
     * @type {Boolean}
     * @private
     */
    this._isActive = permissions.user?.is_active;
    /**
     * @type {Boolean}
     * @private
     */
    this._isAuthenticated = permissions.user?.is_authenticated;
    /**
     * @type {Boolean}
     * @public
     */
    this.hasDisableCache = permissions.user?.has_disable_cache;
  }

  /**
   * @public
   * @param {String} [permName]
   * @param {String} contentTypeId
   * @param {String} objectId
   * @returns {Boolean}
   */
  // TODO not complete, finish this if need this function
  // eslint-disable-next-line no-unused-vars, class-methods-use-this
  hasObjectPerm(permName, contentTypeId, objectId) {
    return false;
  }

  // eslint-disable-next-line class-methods-use-this
  async _getPermsByModuleName(mName) {
    const res = await Axios.get(window.Urls[urls.AUTH_MODULE_PERMS](mName));
    return res.data;
  }

  /**
   * @public
   * @param {String} [permName]
   * @returns {Boolean}
   */
  async hasPerm(permName) {
    if (!this.isActive()) {
      return false;
    }

    if (this.isSuperuser()) {
      return true;
    }

    const mName = permName.split(".")[0];

    // if has permission to module
    if (this.hasModulePerm(mName)) {
      // if has saved perms on Module
      if (this._permsByModule[mName]) {
        // check offline perms
        return this._permsByModule[mName].includes(permName);
      }
      // get perms from API and save for later checking offline
      const response = await this._getPermsByModuleName(mName);
      this._permsByModule[mName] = response.permissions;
      return response.permissions.includes(permName);
    }
    return false;
  }

  /**
   * @public
   * @param {String} [moduleName]
   * @returns {Boolean}
   */
  hasModulePerm(moduleName) {
    return !!(this.isSuperuser() || this._modulePerms[moduleName]);
  }

  /**
   * @public
   * @returns {Boolean}
   */
  isSuperuser() {
    return this._isSuperuser;
  }

  /**
   * @public
   * @returns {Boolean}
   */
  isStaff() {
    return this._isStaff;
  }

  /**
   * @public
   * @returns {Boolean}
   */
  isActive() {
    return this._isActive;
  }

  /**
   * @public
   * @returns {Boolean}
   */
  isAuthenticated() {
    return this._isAuthenticated;
  }

  /**
   * @public
   * @returns {Object}
   */
  getUserDetail() {
    return this._user;
  }
}

/**
 * @typedef {Object} ModulePermissions
 * @property {Object} [permissions]
 */
